import getTranslations from '../helpers/getTranslations';
import getLogoClassName from '../helpers/getLogoClassName';
import getTenantClassName from '../helpers/getTenantClassName';
/**
 * Renders the consent banner with translations.
 */
const getGdprBannerTemplate = () => {
  const translations = getTranslations();
  return `
    <div class="${getTenantClassName()} gdpr-consent-banner gdpr-consent-modal-overlay"
         data-sem="gdpr-consent-banner"
         data-version="2">
      <div class="gdpr-consent-modal">
        <div class="gdpr-consent-modal-header">
          <i class="gdpr-consent-modal-tenant-logo ${getLogoClassName()}"></i>
        </div>
        <div class="gdpr-consent-modal-content">
          <h2 class="gdpr-consent-modal-content-header u-textStyleTitle3">
            ${translations.bannerModalHeader}
          </h2>
          <div class="gdpr-consent-modal-content-body">
            <span class="gdpr-consent-modal-content-body-mobile-text">
              ${translations.bannerMobileBodyText}
            </span>
            <span class="gdpr-consent-modal-content-body-desktop-text">
              ${translations.bannerDesktopBodyText}
            </span>
          </div>
        </div>
        <div class="gdpr-consent-modal-footer">
          <button class="hz-Button hz-Button--primary hz-Button--lg"
                  id="gdpr-consent-banner-accept-button"
                  data-sem="gdpr-consent-banner-accept-button"
                  data-target="/consent">
            ${translations.bannerAcceptButtonText}
          </button>
          <button class="hz-Button hz-Button--secondary hz-Button--lg"
                  id="gdpr-consent-banner-manage-button">
            ${translations.bannerManageButtonText}
          </button>
        </div>
      </div>
    </div>
  `;
};

export default getGdprBannerTemplate;
